import Ring from './components/Ring'
import Bar from './components/Bar'

interface ComponentProps {
  shape: 'ring' | 'bar';
  showNumber?: boolean;
  current: number;
  total: number;
}

const Component = ({ shape, ...rest }: ComponentProps) => {
  if (shape === 'bar') {
    return <Bar {...rest} />;
  } else if (shape === 'ring') {
    return <Ring {...rest} radius={16} stroke={2.5} />;
  } else {
    return <div>Unknown shape</div>;
  }
}

export default Component